<template>
  <div class="commerce-settings main" :key="y">
    <div class="wrapper no-scrollbar">
      <p class="header">
        <span
          style="padding-right: 8px; padding-left: 0; margin-top: -3px"
          @click="back"
        >
          <i class="fa fa-chevron-left" />
        </span>
        <span v-if="!showMenu">
          <span :class="{ 'has-text-info': updating }">
            <span @click="back">{{ $t("settings") }}</span>
            <span style="font-size: 0.6em; margin-left: 6px">
              <span v-if="updating"
                >Updating
                <i class="fa fa-spinner fa-spin has-text-grey fa-sm" />
              </span>
              <span v-else class="link has-text-grey" @click="showJSON"
                >JSON</span
              >
            </span>
          </span>

          <span class="is-pulled-right" style="font-size: 1em">
            <span @click="editMenu">
              {{ $t("ecommerce.edit-menu") }}
              <i class="fa fa-chevron-right" style="margin-left: 4px" />
            </span>
          </span>
        </span>
        <span v-else class="has-text-dark"
          >{{ $t("commerce.menu") }}
          <span
            class="link has-text-grey"
            style="margin-left: 4px; font-size: 0.6em"
            @click="preViewMenu"
            >{{ $t("view") }} <i class="fa fa-external-link-alt fa-sm"
          /></span>

          <div class="is-pulled-right">
            <span
              class="button is-info advanced-btn"
              style="padding: 5px"
              @click="preAdvanced"
            >
              {{ $t("ecommerce.advanced") }}
            </span>
          </div>
        </span>
      </p>

      <div v-if="showMenu" style="margin: 10px 0">
        <div>
          <span v-if="menuUpdatedAt">
            <span class="button is-small is-rounded" style="padding: 7px">
              <i class="fa fa-search" @click="openSearch" /> </span
            >&nbsp;
            <!-- <span class="tag is-light" @click="showUpdatedAt"
              >Updated {{ menuUpdatedAt }}</span
            >&nbsp; -->
            <span
              class="tag is-rounded"
              :class="{ 'is-info': showDescriptions }"
              @click="showDescriptions = !showDescriptions"
            >
              <i
                class="fa fa-quote-left fa-lg"
                style="font-size: 1.1em"
              /> </span
            >&nbsp;
            <span
              class="tag is-rounded"
              :class="{ 'is-info': showStaffNotes }"
              @click="showStaffNotes = !showStaffNotes"
            >
              <i class="fa fa-mitten fa-lg" style="font-size: 1.1em" />
            </span>
          </span>
          <span v-else class="tag is-light">New</span>

          <span class="is-pulled-right is-uppercase">
            <span
              v-for="l in languages"
              :key="l"
              class="button is-small is-rounded"
              :class="{ 'is-white': contentLang !== l }"
              @click="setContentLang(l)"
              >{{ l }}</span
            >
          </span>
        </div>

        <div v-if="showSearch" class="field is-grouped search">
          <div class="control">
            <a class="button" @click="closeSearch"
              ><i class="fa fa-chevron-left"
            /></a>
          </div>
          <div class="control has-icons-left has-icons-right is-expanded">
            <span class="icon is-small is-left">
              <i class="fas fa-search" />
            </span>
            <input
              ref="search"
              class="input is-info"
              placeholder="Search menu"
              v-model="search"
              @keyup="updateSearch($event.target.value)"
            />
            <span
              v-if="search"
              class="icon is-small is-right"
              style="pointer-events: initial"
              @click="search = null"
            >
              <i class="fa fa-times" />
            </span>
          </div>
        </div>

        <input
          type="file"
          ref="file"
          style="display: none"
          accept="image/png,image/jpeg,image/jpg,image/bmp"
          @change="uploadMenuPic($event)"
          :key="zFile"
        />

        <!-- edit menu -->
        <div ref="scrollable" class="menu no-scrollbar gpu-accelerated">
          <div
            v-if="!filteredItems.length"
            class="empty-search"
            @click="search = null"
          >
            <i>No items match your search</i>
            <i class="link is-pulled-right">Clear</i>
          </div>
          <div v-for="(o, i) in filteredItems" :key="i" class="menu-item">
            <div class="field has-addons">
              <div class="control" @click="takePhoto(i)">
                <a
                  v-if="o.pic"
                  class="button"
                  style="border-radius: 0; padding: 0"
                >
                  <img :src="o.pic" />
                </a>
                <a v-else class="button" style="border-radius: 0">
                  <span class="icon">
                    <i class="fa fa-camera-retro" :class="hasPicClass(o)" />
                  </span>
                </a>
              </div>
              <div class="control is-expanded">
                <input class="input" v-model="o.name" placeholder="Item Name" />
                <span class="item-state">
                  <span v-if="o.out_of_stock" class="tag is-danger">
                    {{ $t("commerce.out-of-stock") }}
                  </span>
                  <span v-if="o.hidden" class="tag is-dark">
                    {{ $t("commerce.hidden") }}
                  </span>
                </span>
              </div>
              <div class="control has-icons-left">
                <span
                  class="icon is-small is-left"
                  style="width: 25px; color: grey"
                  >{{ currency }}</span
                >
                <input
                  class="input"
                  style="width: 69px; padding-left: 18px; padding-right: 0"
                  v-model="o.price"
                  type="number"
                  placeholder="Price"
                />
              </div>
              <div class="control">
                <a
                  class="button"
                  style="padding: 4px 4px; border-radius: 0"
                  @click="deleteMenuItem(i)"
                >
                  <i class="fa fa-times-circle has-text-grey" />
                </a>
              </div>
            </div>
            <div class="control notes" style="margin-top: -13px">
              <p
                v-if="showDescriptions"
                style="background-color: rgba(255, 255, 224, 0.5)"
                @click="editDescription(o)"
              >
                <span v-if="o.description">{{ o.description }}</span>
                <span v-else class="hint"
                  ><i
                    ><i class="fa fa-pencil-alt fa-sm" />&nbsp;Item
                    description</i
                  ></span
                >
              </p>
              <p
                v-if="showStaffNotes"
                style="background-color: rgba(254, 216, 77, 0.4)"
                @click="editStaffNotes(o)"
              >
                <span v-if="o.notes">{{ o.notes }}</span>
                <span v-else class="hint"
                  ><i>
                    <i class="fa fa-pencil-alt fa-sm" />&nbsp;Staff notes</i
                  ></span
                >
              </p>
            </div>
            <div style="height: 1px" />
          </div>

          <div class="has-text-centered" style="margin: -5px 0">
            <i
              class="far fa-window-minimize"
              style="width: 30px; margin-bottom: -15px; padding: 0 0"
            />
            <p style="opacity: 0.7; font-weight: 500; margin: 8px">
              {{ $t("ecommerce.end-of-menu") }}
            </p>
          </div>
        </div>

        <nav
          class="level is-mobile"
          style="padding-top: 8px; border-top: 0.5px solid #ddd"
        >
          <div class="level-item has-text-centered" @click="showUpdatedAt">
            <div style="line-height: 1em">
              <p style="color: grey; font-weight: 500; font-size: 0.8em">
                {{ $t("updated") }}
              </p>
              <p style="font-size: 0.9em">
                {{ menuUpdatedAt }}
              </p>
            </div>
          </div>
          <div class="level-item">
            <div>
              <span
                class="button is-link is-outlined is-rounded"
                style="padding: 10px"
                @click="addItemToMenu"
              >
                <i class="fa fa-plus fa-sm" />&nbsp;
                {{ $t("ecommerce.add-item") }}
              </span>
            </div>
          </div>
          <div class="level-item">
            <div>
              <span
                class="button is-success is-outlined is-rounded"
                @click="saveMenu"
              >
                <i class="fa fa-save fa-sm" />&nbsp;
                {{ $t("save") }}
              </span>
            </div>
          </div>
        </nav>

        <!-- <div style="padding-top: 8px; border-top: 0.5px solid #ddd">
          <span class="tag is-light" @click="showUpdatedAt"
            >Updated {{ menuUpdatedAt }}</span
          >
          <span
            class="button is-warning is-rounded"
            style="padding: 10px"
            @click="addItemToMenu"
          >
            <i class="fa fa-plus fa-sm" />&nbsp;Add Item
          </span>
          <span
            class="button is-success is-rounded is-pulled-right"
            @click="saveMenu"
          >
            <i class="fa fa-save fa-sm" />&nbsp;Save
          </span>
        </div> -->
      </div>

      <div v-else :key="z" class="not-menu no-scrollbar">
        <div class="row-wrapper">
          <p class="setting-row" @click="showDiscount = !showDiscount">
            <span class="setting">Menu Discount</span>
            <span class="is-pulled-right">
              <span v-if="currentDiscount" class="tag">{{
                currentDiscount
              }}</span>
              <span v-else class="link">
                {{ $t("setup") }}
              </span>
            </span>
          </p>
          <div
            v-show="showDiscount"
            class="discounts has-text-centered single-line no-scrollbar"
            style="overflow: scroll; width: 100%"
          >
            <p
              class="has-text-left has-text-grey"
              style="margin-bottom: 4px; font-size: 0.9em"
            >
              <i>These discounts will apply to your whole menu</i>
            </p>
            <span :class="discountBtn" @click="preDiscount(0)">
              {{ $t("none") }}
            </span>
            <span :class="discountBtn" @click="preDiscount(10)">10% Off</span>
            <span :class="discountBtn" @click="preDiscount(15)">15% Off</span>
            <span :class="discountBtn" @click="preDiscount(20)">20% Off</span>
            <span :class="discountBtn" @click="preDiscount(25)">25% Off</span>
            <span :class="discountBtn" @click="preDiscount(30)">30% Off</span>
            <span :class="discountBtn" @click="preDiscount(35)">35% Off</span>
            <span :class="discountBtn" @click="preDiscount(40)">40% Off</span>
            <span :class="discountBtn" @click="preDiscount(45)">45% Off</span>
            <span :class="discountBtn" @click="preDiscount(50)">50% Off</span>
          </div>
        </div>

        <div class="row-wrapper">
          <p class="setting-row" @click="toggleOtherDiscounts">
            <span class="setting">Other Discounts</span>
            <span class="is-pulled-right">
              <span v-if="hasOtherDiscounts" class="link">{{
                $t("edit")
              }}</span>
              <span v-else class="link">{{ $t("setup") }}</span>
            </span>
          </p>
          <div
            v-show="showOtherDiscounts"
            class="has-text-left discounts single-line"
            style="width: 100%"
          >
            <span :class="discountBtn" @click="setTakeawayDiscount">
              Take-away Discount
              <span
                v-if="workflow.data.takeaway_discount"
                class="other-discount"
              >
                {{ workflow.data.takeaway_discount }}%
              </span>
            </span>
            <span :class="discountBtn" @click="setDineInDiscount">
              Dine-in Discount
              <span v-if="workflow.data.dinein_discount" class="other-discount">
                {{ workflow.data.dinein_discount }}%
              </span>
            </span>
          </div>
        </div>

        <div v-if="showFreeDeliverySettings">
          <div class="row-wrapper">
            <p
              class="setting-row"
              @click="showFreeDeliveryOver = !showFreeDeliveryOver"
            >
              <span class="setting">Free Delivery Over</span>
              <span class="is-pulled-right">
                <span v-if="currentFreeDeliveryOver" class="tag">{{
                  currentFreeDeliveryOver
                }}</span>
                <span v-else class="tag">{{ $t("none") }}</span>
              </span>
            </p>
            <div
              v-show="showFreeDeliveryOver"
              class="discounts has-text-centered single-line no-scrollbar"
              style="overflow: scroll; width: 100%"
            >
              <span :class="discountBtn" @click="setFreeDeliveryOver(false)">
                <!-- <i class="fa fa-times-circle" style="padding: 3px" /> -->
                {{ $t("none") }}
              </span>
              <span :class="discountBtn" @click="setFreeDeliveryOver(-1)"
                >All</span
              >
              <span
                v-for="val in freeDeliveryOverAmounts"
                :key="val"
                :class="discountBtn"
                @click="setFreeDeliveryOver(val)"
              >
                {{ currency }}{{ val }}
              </span>
            </div>
          </div>

          <div class="row-wrapper">
            <p class="setting-row">
              <span
                class="setting"
                @click="showFreeDeliveryTo = !showFreeDeliveryTo"
              >
                Free Delivery To
              </span>
              <span class="is-pulled-right">
                <span
                  class="tags has-addons is-marginless"
                  style="display: inline-block; padding-left: 5px"
                  @click="setFreeDeliveryTo"
                >
                  <span v-if="freeDeliveryTo" class="tag is-grey">
                    {{ freeDeliveryTo }}
                    <span
                      v-if="!workflow.data.free_delivery_polygon"
                      class="has-text-danger"
                      style="margin-left: 4px"
                    >
                      Set Area!
                    </span>
                  </span>
                  <span v-else class="tag">{{ $t("none") }}</span>
                </span>
              </span>
            </p>
            <!-- <div
                v-if="freeDeliveryTo && !workflow.data.free_delivery_polygon"
                class="has-text-right"
              >
                <i style="color:orange">
                  <i class="fa fa-map" />&nbsp;Contact TUK to complete setup
                </i>
              </div>-->
            <div
              v-show="showFreeDeliveryToOptions"
              class="has-text-left discounts single-line"
              style="width: 100%"
            >
              <span :class="discountBtn" @click="setCustom">
                <i class="far fa-square" />&nbsp;Custom
              </span>
              <span :class="discountBtn" @click="setRadius">
                <i class="far fa-dot-circle" />&nbsp;Radius
              </span>
              <span :class="discountBtn" @click="clearPolygon">
                <!-- <i class="fa fa-times-circle" style="padding: 3px" /> -->
                <i class="far fa-trash-alt" />&nbsp;Delete
              </span>
            </div>
          </div>
        </div>

        <div v-if="isSelfDelivery">
          <div class="row-wrapper">
            <p class="setting-row" @click="setDeliveryFeePerKM">
              <span class="setting">Delivery Fee Per KM</span>
              <span class="is-pulled-right">
                <span v-if="deliveryFeePerKM" class="tag is-success"
                  >{{ currency }}{{ deliveryFeePerKM }} per km</span
                >
                <span v-else class="tag">{{ $t("none") }}</span>
              </span>
            </p>
          </div>

          <div class="row-wrapper">
            <p class="setting-row" @click="setMinDeliveryFee">
              <span class="setting">Min Delivery Fee</span>
              <span class="is-pulled-right">
                <span v-if="minDeliveryFee" class="tag is-success"
                  >{{ currency }}{{ minDeliveryFee }}</span
                >
                <span v-else class="tag">{{ $t("none") }}</span>
              </span>
            </p>
          </div>

          <div class="row-wrapper">
            <p class="setting-row" @click="setMaxDistance">
              <span class="setting">Max Delivery Distance</span>
              <span class="is-pulled-right">
                <span v-if="maxDistance" class="tag is-success"
                  >{{ maxDistance }} km</span
                >
                <span v-else class="tag">{{ $t("none") }}</span>
              </span>
            </p>
          </div>
        </div>

        <div class="row-wrapper">
          <p class="setting-row" @click="setMinOrder">
            <span class="setting">Minimum Order</span>
            <span class="is-pulled-right">
              <span v-if="minOrder" class="tag">
                {{ currency }}{{ minOrder }}
              </span>
              <span v-else>
                <i class="link">{{ $t("Caution") }}</i>
              </span>
            </span>
          </p>
        </div>

        <!-- <div class="row-wrapper">
          <p class="setting-row" @click="facebookAds">
            <span class="setting">
              <i class="fab fa-facebook" />&nbsp;Facebook Ads
            </span>
            <span class="is-pulled-right">
              <i class="has-text-danger" style="font-size: 0.9em; opacity: 0.6"
                >Free Credit!</i
              >&nbsp;
              <i class="link">Ask Us</i>
            </span>
          </p>
        </div> -->

        <hr />

        <!-- <div @click="setShopInfo"> -->
        <div class="row-wrapper" @click="goto(`/commerce_page/business-info`)">
          <p class="setting-row">
            <span class="setting">
              <i class="fa fa-store-alt fa-sm" />&nbsp;{{ $t("Shop Info") }}
            </span>
            <span class="is-pulled-right link"> Update Info </span>
          </p>
        </div>

        <!-- <div @click="setShopHours"> -->
        <div class="row-wrapper" @click="goto(`/commerce_page/set-hours`)">
          <p class="setting-row">
            <span class="setting">
              <i class="far fa-clock fasm" />&nbsp;{{ $t("Shop Hours") }}
            </span>
            <span class="is-pulled-right link"> Change Hours </span>
          </p>
        </div>

        <div class="row-wrapper" @click="goto(`/commerce_page/set-hours`)">
          <!-- <p class="setting-row" @click="showShopClosed = !showShopClosed"> -->
          <p class="setting-row">
            <span class="setting">
              <i class="far fa-calendar-alt fa-sm" />&nbsp;Shop Holiday
            </span>
            <span class="is-pulled-right">
              <span v-if="shopClosed" class="tag is-danger"
                >Closed until {{ shopClosed }}</span
              >
              <span v-else class="link">{{ $t("Put On Holiday") }}</span>
            </span>
          </p>
          <div v-show="showShopClosed" class="has-text-left">
            <!-- discounts single-line no-scrollbar" -->
            <p style="margin-bottom: 4px">
              <i>{{ $t("commerce.close-for-how-many-days") }}</i>
            </p>
            <span
              class="has-text-left discounts single-line no-scrollbar"
              style="width: 100%"
            >
              <span :class="infoBtn" @click="setShopClosed(1)">1 Day</span>
              <span :class="infoBtn" @click="setShopClosed(2)">2 Days</span>
              <span :class="infoBtn" @click="setShopClosed(3)">3 Days</span>
              <span :class="infoBtn" @click="setShopClosed(4)">4 Days</span>
              <span :class="infoBtn" @click="setShopClosed(60)">Manual</span>
            </span>
            <p
              v-if="shopClosed"
              class="button is-small is-success is-outlined"
              @click="setShopClosed(null)"
            >
              Re-open (Revert to normal hours)
            </p>
          </div>
        </div>

        <div class="row-wrapper">
          <p class="setting-row">
            <span class="setting">
              <i class="fa fa-users" />&nbsp;{{ $t("staff") }}
            </span>
            <span class="is-pulled-right link" @click="addCommerceAgent">
              <i class="fa fa-plus fa-sm" />
              {{ $t("commerce.add-staff") }}
            </span>
          </p>
        </div>

        <div class="row-wrapper" v-if="hasSelfDelivery">
          <p class="setting-row">
            <span class="setting">
              <i class="fa fa-motorcycle" />&nbsp;{{ $t("drivers") }}
            </span>
            <span class="is-pulled-right link" @click="addDeliveryDriver">
              <i class="fa fa-plus fa-sm" />
              {{ $t("commerce.add-driver") }}
            </span>
          </p>
        </div>

        <div class="row-wrapper" @click="notify">
          <p class="setting-row">
            <span class="setting">
              <i class="fa fa-bullhorn" />&nbsp;{{ $t("notifications") }}
            </span>
            <span class="is-pulled-right link">
              <i
                class="far fa-bell has-text-success"
                :class="
                  $store.getters.getNotificationToken
                    ? 'has-text-success'
                    : 'has-text-danger'
                "
              />&nbsp;{{ $t("test") }}
            </span>
          </p>
        </div>

        <div class="row-wrapper" @click="downloadSound">
          <p class="setting-row">
            <span class="setting">
              <i class="fa fa-music" />&nbsp;{{ $t("Sounds") }}
            </span>
            <span class="is-pulled-right link">
              <i class="fa fa-download" />&nbsp;{{ $t("Download") }}
            </span>
            <a
              ref="short_sound"
              href="/sounds/parrot.mp3"
              download="tuk_short_sound"
              hidden
            />
            <a
              ref="long_sound"
              href="/sounds/muay_thai.mp3"
              download="tuk_long_sound"
              hidden
            />
          </p>
        </div>
      </div>
    </div>

    <div v-if="!showMenu" class="notification is-white has-text-grey">
      <p style="margin-bottom: 8px">
        <i @click="viewInstagramMenu">{{
          $t("commerce.use-these-to-get-more-orders")
        }}</i>
        <span
          v-if="isSuperUser()"
          class="link is-pulled-right has-text-weight-light"
          @click="goto('commerce')"
          >Manual</span
        >
      </p>
      <p @click="contactMerchantSupport">
        {{ $t("commerce.need-help") }}
        <span class="is-pulled-right has-text-link">
          <i class="far fa-comment" style="margin-right: 6px" />
          <span class="link">{{ $t("contact-us") }}</span>
          <i class="fa fa-chevron-right" style="margin-left: 6px" />
        </span>
      </p>
    </div>

    <!-- <fade-transition>
      <CommerceDigitalMenu
        v-if="showMenu"
        :workflow="selected"
        @close="showMenu = null"
      />
    </fade-transition> -->
  </div>
</template>

<script>
import imageCompression from "browser-image-compression";
import { sounds } from "../functions.js";
import pricing from "@/pricing";
// import CommerceDigitalMenu from "@/components/CommerceDigitalMenu.vue";

const shortid = require("shortid");

export default {
  name: "CommerceSettings",
  components: {
    // CommerceDigitalMenu,
  },
  data() {
    return {
      search: null,
      searchTerm: null,
      showSearch: false,
      showOtherDiscounts: false,
      showDiscount: false,
      showFreeDeliveryOver: false,
      showFreeDeliveryTo: false,
      showShopClosed: false,
      updating: false,
      liveLink: null,
      promoLink: null,
      items: [], // menu items
      showMenu: false,
      menu: null,
      picIndex: 0, // used for photo upload
      contentLang: "en", // default English
      languageBool: false,
      showStaffNotes: false,
      showDescriptions: true,
      z: 0, // not being used, might not be necessary
      zFile: 100, // attempt to fix Jig bug of uploading same file to different item
      y: 0, // hack
    };
  },
  computed: {
    filteredItems() {
      console.log("searchTerm", this.searchTerm);
      if (!this.searchTerm) return this.items;
      // var searchTerm = this.search.toLowerCase();
      return this.items.filter((i) => {
        return JSON.stringify(i).toLowerCase().includes(this.searchTerm);
      });
    },
    showFreeDeliverySettings() {
      if (this.isSubsidisedDeliveryPlan) return false;
      return this.workflow.data.delivery;
    },
    isSubsidisedDeliveryPlan() {
      return pricing.hasFreeDelivery(this.workflow.data.fruit);
      // if (!this.workflow.data.fruit) return false;
      // return this.workflow.data.fruit.includes("p_");
    },
    showFreeDeliveryToOptions() {
      if (this.showFreeDeliveryTo) return true;
      if (this.freeDeliveryTo) return !this.workflow.data.free_delivery_polygon;
      return false;
    },
    freeDeliveryOverAmounts() {
      if (this.business.country === "sg") {
        return [9, 19, 29, 39, 49, 59, 69, 79, 89, 99]; // sgd intervals
      }
      return [99, 149, 199, 249, 299, 349, 399, 449, 499, 549, 599]; // thai baht intervals
    },
    discountBtn() {
      //   return "button is-small is-grey is-rounded has-text-link";
      return "button is-small is-grey";
    },
    infoBtn() {
      return "button is-small is-grey";
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    languages() {
      return this.workflow.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    business() {
      return this.role.business;
    },
    currency() {
      return this.currencySymbol(this.business.country);
    },
    menuUpdatedAt() {
      if (this.menu) {
        return new Date(this.menu.updated_at)
          .toLocaleDateString("en-GB")
          .substring(0, 5);
      }
      return null;
    },
    languageClass() {
      if (this.languageBool) return "is-success";
      return "is-danger";
    },
    currentDiscount() {
      var d = {};
      var none = true; // track if there are none
      this.items.forEach((o) => {
        if (o.discount) {
          none = false;
          if (d[o.discount]) d[o.discount] += 1;
          else d[o.discount] = 1;
        }
      });
      if (none) return null;
      var str = ``;
      for (var [k, v] of Object.entries(d)) {
        str = str + `${k}% (${v}), `;
      }
      return str.slice(0, -2);
    },
    currentFreeDeliveryOver() {
      if (!this.workflow.data.free_delivery_over) return null;
      // if (typeof this.workflow.data.free_delivery === "boolean") return `All orders`;
      // return "฿" + this.workflow.data.free_delivery;
      if (this.workflow.data.free_delivery_over === -1) return `All orders`;
      return this.currency + this.workflow.data.free_delivery_over;
    },
    freeDeliveryTo() {
      if (!this.workflow.data.free_delivery_to) return null;
      return this.workflow.data.free_delivery_to;
    },
    hasOtherDiscounts() {
      return (
        this.workflow.data.takeaway_discount ||
        this.workflow.data.dinein_discount
      );
    },
    minOrder() {
      return this.workflow.data.min_order;
    },
    maxDistance() {
      return this.workflow.data.max_distance;
    },
    minDeliveryFee() {
      return this.workflow.data.min_delivery_fee;
    },
    deliveryFeePerKM() {
      return this.workflow.data.delivery_fee_per_km;
    },
    isSelfDelivery() {
      if (this.workflow.data.fallback_fleet) return false;
      return this.workflow.data.express === "self";
    },
    hasSelfDelivery() {
      return (
        this.workflow.data.express === "self" ||
        this.workflow.data.fallback_fleet === "self"
      );
    },
    closedUntil() {
      if (!this.workflow.data.closed_until) return null;
      return this.isFutureTime(this.workflow.data.closed_until);
    },
    shopClosed() {
      if (!this.closedUntil) return null;
      return this.shortDateTime(this.workflow.data.closed_until);
      //   return this.workflow.data.shop_closed; // { date: '2020-07-01', n_days: 3}
    },
  },
  mounted() {
    // EventBus.$on("OPEN_COMMERCE_SETTINGS", () => {
    //   console.log("open commerce settings");
    //   this.getBlobs();
    // });
    this.getBlobs();
    this.addItemToMenu();
  },
  beforeDestroy() {
    // EventBus.$off("OPEN_COMMERCE_SETTINGS");
  },
  methods: {
    back() {
      if (this.showMenu) {
        this.showMenu = false;
        return;
      }
      this.$emit("close");
    },
    viewInstagramMenu() {
      this.goto(`/shop/${this.business.id}?insta=true`);
    },
    toggleOtherDiscounts() {
      this.showOtherDiscounts = !this.showOtherDiscounts;
    },
    updateSearch(txt) {
      if (!txt) this.searchTerm = null;
      else this.searchTerm = txt.toLowerCase(); // a hack for mobile...
    },
    openSearch() {
      this.showSearch = true;
      this.search = null; // clear any old search
      this.$nextTick(() => this.$refs.search.focus());
    },
    closeSearch() {
      this.showSearch = false;
      this.search = null; // clear any old search
      this.searchTerm = null;
    },
    downloadSound() {
      sounds("parrot");
      var title = this.$t("squawk.title");
      var steps = this.$t("squawk.steps");
      var step1 = this.$t("squawk.1");
      var step2 = this.$t("squawk.2");
      var step3 = this.$t("squawk.3");
      // var download = this.$t("squawk.download");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.3em'>
        <i class='fab fa-earlybirds'></i>&nbsp;${title}
        </p>
        <p style='margin-bottom:12px'><i>${steps}</i></p>
        <p>1. <i class='fa fa-download'></i>&nbsp;${step1}</p>
        <p>2. <i class='fa fa-folder-plus'></i>&nbsp;${step2}</p>
        <p>3. <i class='fa fa-cog'></i>&nbsp;${step3}</p>
        <p style='margin-top:10px'>
        <i style='font-size:0.8em; opacity:0.6'>*Android phones can set custom notification sounds</i>
        </p>
        </div>`,
        showCloseButton: true,
        // confirmButtonText: `${download}&nbsp;<i class='fa fa-download'></i>`,
        confirmButtonText: "Short Sound",
        cancelButtonText: "Long Sound",
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return;
        var sound = "long_sound";
        if (val.value) sound = "short_sound";
        this.$refs[sound].click();
        var loader = this.loadingDots("cyan");
        setTimeout(() => {
          loader.hide();
          this.$swal({
            title: this.$t("success"),
            text: `tuk_${sound}.mp3 saved to downloads folder`,
            showConfirmButton: false,
            showCloseButton: true,
            type: "success",
            timer: 6000,
          });
        }, 500);
      });
    },
    preAdvanced() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px;'>
        <i class='fa fa-arrow-right'></i>&nbsp;Advanced Menu Editor</p>
        <p><i>Remember to save any edits you made to your menu before leaving this page.</i></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, I've Saved",
      }).then((val) => {
        if (!val.value) return;
        this.goto("menu_editor");
      });
    },
    preViewMenu() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px;'>
        <i class='fa fa-arrow-right'></i>&nbsp;View Menu</p>
        <p><i>Remember to save any edits you made to your menu before leaving this page.</i></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, I've Saved",
      }).then((val) => {
        if (!val.value) return;
        this.viewMenu();
      });
    },
    setShopInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
          <i class='fa fa-store-alt'></i>&nbsp;
          ${this.$t("Update Shop Info")}
        </p>
        <p style='margin-top:12px'>
Let us know when your shop info needs to be updated.
        </p>
        <p style='margin-top:12px'>
For example you change change your shop phone number, email address or physical store location.
        </p>
        <p style='margin-top:12px'>
Changes will be visible in the app within 24 hours.   
        </p>
        <p style='margin-top:12px; font-size:0.9em; opacity:0.8'>
<i>Examples:</i>
<br>
<i>Update restaurant phone number to 0909123456</i>
<br>
<i>Update store email to staff@shop.com</i>
        </p>
        <br>
        </div>`,
        input: "textarea",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (txt) => {
          if (!txt) return `Enter updated shop info`;
          if (txt.length < 4) return `Enter valid shop info`;
        },
      }).then((val) => {
        if (!val.value) return;
        this.sendEmail("set_shop_info", val.value);
      });
    },
    facebookAds() {
      var blue = this.bulmaColor("link");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
          <i class='fab fa-facebook' style='color: ${blue}'></i>&nbsp;
          ${this.$t("Facebook Ads")}
        </p>
        <p style='margin-top:12px'>
You can easily run Facebook Ads to reach customers in your area!
        </p>
        <p style='margin-top:12px'>
<i style='font-weight:500; color:red; opacity:0.6'>Special Promo!</i>&nbsp;
TUK will match your advertising spend to double the impact of ads you run with us.
        </p>
        <p style='margin-top:12px'>
Choose between advertising packages ranging from 2,000 - 5,000 baht per month. 
<br><i style='font-weight:550; font-size:0.9em; color:lightgreen'>Worth 4,000 - 10,000 baht!</i> 
        </p>
        <p style='margin-top:12px; font-size:0.9em; opacity:0.8'>
<i>How much would you like to spend on advertising?</i>
        </p>
        <br>
        </div>`,
        input: "number",
        showCloseButton: true,
        confirmButtonText: this.$t("Submit Enquiry"),
        inputValidator: (n) => {
          if (!n) return `Enter a value`;
          if (parseInt(n) < 2000) return `Enter a value of at least 2000`;
        },
      }).then((val) => {
        if (!val.value) return;
        this.sendEmail("facebook_ads_equiry", val.value);
        this.$swal({
          type: "success",
          html: `<p style='font-size:1.2em; margin-bottom:12px'>🙏🏼 Thank you!</p>
          <p>Our advertising manager will reach out to you with more details.</p>`,
          showCloseButton: true,
        });
      });
    },
    setShopHours() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
          <i class='far fa-clock'></i>&nbsp;
          ${this.$t("Shop Operating Hours")}
        </p>
        <p style='margin-top:12px'>
Please enter your new operating hours in the text box below. 
        </p>
        <p style='margin-top:12px'>
It may take up to 24 hours for the operating hours to update on the app.
        </p>
        <p style='margin-top:12px'>
You can also put your shop on holiday or pause your shop the rest of today.        
        </p>
        <p style='margin-top:12px; font-size:0.9em; opacity:0.8'>
<i>Example: 10:00 - 20:30 Daily</i>
        </p>
        <br>
        </div>`,
        input: "textarea",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (txt) => {
          if (!txt) return `Enter new shop hours`;
          if (txt.length < 4) return `Enter valid operating hours`;
        },
      }).then((val) => {
        if (!val.value) return;
        this.sendEmail("set_shop_hours", val.value);
      });
    },
    sendEmail(type, data) {
      this.showSetEmail = false;
      var obj = {
        type: type,
        shop_name: this.business.name,
        request: data,
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("sendEmail", obj)
        .then(() => {
          if (type === "facebook_ads_equiry") return;
          var msg = "Thank you!<br>Your shop will be updated within 24 hours";
          this.successToast(msg, "top", 8000);
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
    // viewShop() {
    //   this.$router.push(`/shop/${this.role.business_id}?tab=info`);
    // },
    viewMenu() {
      this.$router.push(`/shop/${this.role.business_id}?tab=menu`); // promos
    },
    syntaxHighlight(json) {
      if (typeof json != "string") {
        json = JSON.stringify(json, undefined, 2);
      }
      json = json
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      return json.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
        function (match) {
          var cls = "number";
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = "key";
            } else {
              cls = "string";
            }
          } else if (/true|false/.test(match)) {
            cls = "boolean";
          } else if (/null/.test(match)) {
            cls = "null";
          }
          return '<span class="' + cls + '">' + match + "</span>";
        }
      );
    },
    showJSON() {
      if (!this.isSuperUser()) return; // only do for super user
      // var YAML = require("json2yaml");
      // var ymlText = YAML.stringify(this.workflow.data);
      // var json = JSON.stringify(this.workflow.data, null, 2);
      // json = json.substring(1, json.length - 1).replace(/^\s+|\s+$/g, ""); // trim {} and white space
      var ymlText = JSON.stringify(this.workflow.data, null, 2);
      this.$swal({
        html: `<div style='text-align:left'>
<p style='margin-bottom:10px'>JSON Settings</p>
<pre style='background-color: #2A4F5C; color: #F8F693; border-radius:3px; padding: 6px; font-size:10pt; line-height:1.6em; max-height: calc(100vh - 170px); overflow: scroll; font-family: Consolas,monaco,monospace;'>
${ymlText}
</pre>
</div>`,
        showCloseButton: true,
        confirmButtonText: "Edit",
      }).then((val) => {
        if (val.value) this.goto("/business_profile/" + this.business.id);
      });
    },
    notify() {
      this.log("check_notifications", "commerce_agent");
      var msg = `Sending notification to this device <i class='fa fa-spinner fa-spin'></i>`;
      this.infoToast(msg);
      sounds("navigate1");
      this.sendPushNotification("Hi from TUK 👍🏼", this.userID());
    },
    addDeliveryDriver() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
          <i class='fa fa-motorcycle'></i>&nbsp;Add Delivery Driver
        </p>
        <p style='margin-top:12px'>
Enter the mobile number of the new delivery driver you'd like to add to your self delivery fleet.
        </p>
        <p style='margin-top:12px'>
After we've notified you that their account is setup ask the driver to login to TUK App with the same number.
        </p>
        <p style='margin-top:12px; font-size:0.9em; opacity:0.8'>
<i>Example: 0909123456</i>
        </p>
        <br>
        </div>`,
        input: "textarea",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (txt) => {
          if (!txt) return `Enter new delivery driver's mobile`;
          if (txt.length < 8) return `Enter a mobile phone number`;
        },
      }).then((val) => {
        if (!val.value) return;
        this.sendEmail("add_driver_to_self_delivery_fleet", val.value);
      });
    },
    addCommerceAgent() {
      var r = this.role;
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em; margin-bottom:10px'>
        <i class="fa fa-users"></i>&nbsp;Add Staff Member
        </p>
        <p style='margin-bottom:10px'>${r.business.name} - ${r.role_name}</p>
        <div style='font-size:0.85em'>
        <p style='margin-bottom:10px'><i>Enter the mobile number used for TUK App login.</i></p>
        <p><i>Each staff should use their own mobile number to ensure they get the order notifications.</i></p>
        </div>
        </div>`,
        input: "text", //"number",
        inputValue: "+66",
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 10) return "You must enter a mobile number!";
          if (!this.parsePhoneNumber(val)) return "Invalid phone number!";
          var loader = this.loadingDots("blue");
          this.$store
            .dispatch("createRole", {
              phone_number: this.parsePhoneNumber(val),
              business_id: r.business_id,
              workflow_id: r.workflow_id,
              workflow_name: r.workflow_name,
              role_type: r.role_type,
              role_name: r.role_name,
            })
            .then(() => {
              this.success("Ask your staff to restart their TUK App.");
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        },
      });
    },
    parsePhoneNumber(raw) {
      raw = raw.replace(/[^\d+]/g, ""); // remove non-numeric, keep +
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return null;
    },
    shopClosedInfo() {
      var red = this.bulmaColor("danger");
      var blue = this.bulmaColor("info");
      this.$swal({
        title: `<i class='fa fa-clock' style='color:${red}'></i>&nbsp;<i class='fa fa-calendar' style='color:${blue}'></i>`,
        html: `Is your shop closed today?<br><br>Let your customers know when you're not operating normal hours.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    setShopClosed(days) {
      this.workflow.data.closed_until = null; // default
      if (days) {
        var dt = new Date();
        dt.setDate(dt.getDate() + days);
        this.workflow.data.closed_until = dt.toISOString();
      }

      var loader = this.loadingDots("palegreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          business_id: this.workflow.business_id,
          data: this.workflow.data,
        })
        .then(() => {
          this.showShopClosed = false;
          if (!days) this.successToast(`Success! Shop open normal hours`);
          else this.successToast(`Success! Shop closed ${days} days`);
          this.y += 1; // not working
          this.z += 1;
          this.refreshPage();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
      return;

      // var red = this.bulmaColor("danger");
      // var blue = this.bulmaColor("info");
      // this.$swal({
      //   title: `<i class='fa fa-clock' style='color:${red}'></i>&nbsp;<i class='fa fa-calendar' style='color:${blue}'></i>`,
      //   html: `<strong>Is your shop closed today?</strong><br><br>Let your customers know when you're not operating normal hours.`,
      //   showConfirmButton: true,
      //   showCancelButton: true,
      //   showCloseButton: true,
      //   confirmButtonText: "Close Shop Today",
      //   cancelButtonText: "Normal Hours Today",
      //   confirmButtonColor: red,
      //   cancelButtonColor: blue
      // }).then(val => {
      //   if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

      //   if (val.value) {
      //     var dt = new Date();
      //     dt.setDate(dt.getDate() + 1);
      //     this.workflow.data.closed_until = dt.toISOString();
      //   } else {
      //     this.workflow.data.closed_until = null;
      //   }

      //   var loader = this.loadingDots("palegreen");
      //   this.$store
      //     .dispatch("updateWorkflow", {
      //       id: this.workflow.id,
      //       data: this.workflow.data
      //     })
      //     .then(() => this.$toast.open("Success"))
      //     .catch(err => this.apiError(err))
      //     .finally(() => loader.hide());
      // });
    },
    setDeliveryFeePerKM() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-route'></i>&nbsp;<i class='fa fa-coins'></i></div>`,
        html: `Set delivery fee per KM.<br><br>E.g. at 10 baht per km, 4.5 km = 45 baht delivery fee.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.delivery_fee_per_km,
        inputPlaceholder: this.currency + "10 per km",
        inputValidator: (val) => {
          if (!val) return `Enter a delivery fee per km or delete`;
          if (val > 80) return `Are you sure that's right? Enter per km fee.`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var fee = parseFloat(val.value);
        if (val.dismiss === "cancel") fee = null; // cancel deletes

        this.workflow.data.delivery_fee_per_km = fee;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMinDeliveryFee() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-money-bill-alt'></i>&nbsp;<i class='fa fa-shipping-fast'></i></div>`,
        html: `Set a minimum delivery fee.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.min_delivery_fee,
        inputPlaceholder: "15",
        inputValidator: (val) => {
          if (!val) return `Enter a minimum delivery fee or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var fee = parseFloat(val.value);
        if (val.dismiss === "cancel") fee = null; // cancel deletes

        this.workflow.data.min_delivery_fee = fee;

        var loader = this.loadingDots("orange");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => {
            this.successToast("Success");
            this.y += 1;
          })
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMaxDistance() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-route'></i>&nbsp;<i class='fa fa-shipping-fast'></i></div>`,
        html: `Set max delivery distance<br><br>Customers will not be able to order a delivery beyond this distance.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.max_distance,
        inputPlaceholder: "10 km",
        inputValidator: (val) => {
          if (!val) return `Enter a maximum distance in km or delete`;
          if (val > 70) return `Enter distance in kilometers not meters`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var max = parseFloat(val.value);
        if (val.dismiss === "cancel") max = null; // cancel deletes

        this.workflow.data.max_distance = max;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setDineInDiscount() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-tag'></i>&nbsp;Dine-in Discount
        </p>
        <p style='margin-bottom:10px'>Set a percent discount for dine-in orders.</p>
        <p style='margin-bottom:10px'>This will appear as "Dine-in Discount" line-item on the receipt.</p>
        <p style='font-size:0.85em; opacity:0.7'><i>*This is recommended to increase your dine-in orders.</i></p>
        </div>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.dinein_discount,
        inputPlaceholder: "15%",
        inputValidator: (val) => {
          if (!val || parseInt(val) > 100 || parseInt(val) < 0)
            return `Enter a number between 0-100% or Delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything
        var discount = parseInt(val.value);
        if (val.dismiss === "cancel") discount = null; // cancel deletes
        this.workflow.data.dinein_discount = discount;
        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setTakeawayDiscount() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-tag'></i>&nbsp;Takeaway Discount
        </p>
        <p style='margin-bottom:10px'>Set a percent discount for takeaway orders.</p>
        <p style='margin-bottom:10px'>This will appear as "Takeaway Discount" line-item on the receipt.</p>
        <p style='font-size:0.85em; opacity:0.7'><i>*This is recommended to increase your takeaway orders.</i></p>
        </div>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.takeaway_discount,
        inputPlaceholder: "15%",
        inputValidator: (val) => {
          if (!val || parseInt(val) > 100 || parseInt(val) < 0)
            return `Enter a number between 0-100% or Delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything
        var discount = parseInt(val.value);
        if (val.dismiss === "cancel") discount = null; // cancel deletes
        this.workflow.data.takeaway_discount = discount;
        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMinOrder() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-coins'></i>&nbsp;
        Minimum Order
        </p>
        <p style='margin-bottom:10px'>Set a minimum order value.</p>
        <p style='margin-bottom:10px'>Customers will need to spend at least this much to place an order.</p>
        <p style='font-size:0.85em; opacity:0.7'><i>*This is not recommended for most shops.</i></p>
        </div>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.min_order,
        inputPlaceholder: this.currency + "100",
        inputValidator: (val) => {
          if (!val) return `Enter a minimum order value or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var min = parseFloat(val.value);
        if (val.dismiss === "cancel") min = null; // cancel deletes

        this.workflow.data.min_order = min;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setRadius() {
      var green = this.bulmaColor("success");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-dot-circle'></i>&nbsp;Set Radius
        </p>
        <p style='margin-bottom:10px'>Provide free delivery in a radius around your shop.</p>
        <p><i>Enter radius in meters.</i></p>
        </div>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Set Radius",
        cancelButtonText: "Cancel",
        // cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: green,
        input: "number",
        inputValue: this.workflow.data.free_delivery_to,
        inputPlaceholder: "5000 meters",
        inputValidator: (val) => {
          if (!val) return `Enter a radius or cancel`;
          if (parseInt(val) < 100) return `Enter radius in meters, > 100m`;
        },
      }).then((val) => {
        if (val.value) {
          this.saveCirclePolygon(parseInt(val.value));
        }
      });
    },
    saveCirclePolygon(radiusMeters) {
      const circleToPolygon = require("circle-to-polygon");
      const coordinates = [this.business.lon, this.business.lat]; //[lon, lat]
      const radius = radiusMeters;
      const numberOfEdges = 32; //optional that defaults to 32
      var polygon = circleToPolygon(coordinates, radius, numberOfEdges);
      // console.log("polygon", polygon);
      this.workflow.data.free_delivery_polygon = polygon.coordinates;
      var loader = this.loadingDots("teal");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => {
          this.$toast.open("Success");
          this.y += 1;
          this.showFreeDeliveryTo = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    clearPolygon() {
      this.workflow.data.free_delivery_polygon = null;
      var loader = this.loadingDots("teal");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => {
          this.showFreeDeliveryTo = false;
          this.successToast("Success");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    setCustom() {
      var green = this.bulmaColor("primary");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map'></i>&nbsp;Set Custom Area
        </p>
        <p>Set a custom area or neighbourhood for free delivery.</p>
        <p><i>Please contact the TUK team to set this up.</i></p>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: green,
        confirmButtonText: "Contact TUK",
        cancelButtonText: "Later",
      }).then((val) => {
        if (val.value) return window.open("https://m.me/tukapp", "_blank");
      });
    },
    setFreeDeliveryTo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map'></i>&nbsp;Free Delivey To...
        </p>
        <p style='margin-bottom:10px'>Provide free delivery to a certain neighbourhood.</p>
        <p><i>Please contact the TUK team to set this up.</i></p>
        </div>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "text",
        inputValue: this.workflow.data.free_delivery_to,
        inputPlaceholder: "Old Town",
        inputValidator: (val) => {
          if (!val) return `Enter an area name or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var name = val.value;
        if (val.dismiss === "cancel") name = null; // cancel deletes

        this.workflow.data.free_delivery_to = name;
        if (!name && !this.workflow.data.free_delivery_over) {
          this.workflow.data.free_delivery = false;
        } else {
          this.workflow.data.free_delivery = true;
        }

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => {
            this.$toast.open("Success");
            this.z += 1;
            this.showFreeDeliveryTo = false;
          })
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setFreeDeliveryOver(amount) {
      if (!amount) {
        this.workflow.data.free_delivery_over = false;
        if (!this.workflow.data.free_delivery_to) {
          this.workflow.data.free_delivery = false;
        }
      } else {
        this.workflow.data.free_delivery_over = amount;
        this.workflow.data.free_delivery = true;
      }

      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => {
          this.$toast.open("Success");
          this.showFreeDeliveryOver = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    freeDeliveryOverInfo() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-shipping-fast'></i></div>`,
        html: `Provide free delivery over a certain order value.<br><br><i>Please contact the TUK team with any questions.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    freeDeliveryToInfo() {
      this.$swal({
        title: `<div style='color:gold'><i class='fa fa-map'></i></div>`,
        html: `Provide free delivery to a certain neighbourhood.<br><br><i>Please contact the TUK team to set this up.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    menuDiscountInfo() {
      this.$swal({
        title: `<div style='color:red'><i class='fa fa-tags'></i></div>`,
        html: `Choose a discount rate to apply to your digital menu.<br><br>Discounts will last until you turn them off.<br><br><i>This will override any individual item discounts.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    dailyPromoInfo() {
      this.$swal({
        title: `<div style='color:blue'><i class='fab fa-facebook'></i></div>`,
        html: `Paste link to daily promo, such as a facebook post.<br><br>Promos will last for 24 hours or until you turn them off.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    facebookLiveInfo() {
      this.$swal({
        title: `<div style='color:lightgreen'><i class='fa fa-video'></i></div>`,
        html: `Paste link to your live video such as facebook live.<br><br>Your shop will be promoted for up to 12 hours every time you go live.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    showUpdatedAt() {
      if (!this.menu) return;
      var dt = new Date(this.menu.updated_at).toLocaleString("en-GB");
      var msg = `Menu last updated<br>${dt}`;
      this.$swal({
        title: "<i class='far fa-clock'></i>",
        html: msg,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    setContentLang(lang, isInit) {
      if (!isInit) this.saveContent();
      this.contentLang = lang;
      this.setContent();
    },
    setContent() {
      this.items.forEach((o) => {
        if (o[this.contentLang]) {
          o.name = o[this.contentLang].name;
          o.description = o[this.contentLang].description;
        }
      });
      this.languageBool = false;
      if (this.items.length > 0) {
        if (!this.items[0].languages) return;
        this.languageBool = this.items[0].languages[this.contentLang];
      }
    },
    saveContent() {
      // don't need to do anything if no items, length 0
      this.items.forEach((o) => {
        o[this.contentLang] = {
          name: o.name,
          description: o.description,
        };
        // check if id exists, if not add one
        if (!o.id) o.id = shortid.generate(); // should change id if name/price changes
        // also save language on/off state, on first item only
        if (!o.languages) o.languages = {};
        o.languages[this.contentLang] = this.languageBool;
      });
    },
    preDiscount(discount) {
      var conflict = false;
      this.items.forEach((o) => {
        if (o.discount) {
          if (o.discount !== discount) conflict = true;
        }
      });
      if (!conflict) return this.applyDiscount(discount);
      var red = this.bulmaColor("danger");
      this.$swal({
        type: "info",
        title: `<div style='color:${red}'>Discount ${discount}&nbsp;<i class="fa fa-percent"></i></div>`,
        html: `This discount rate will override existing discounts on all menu items.`,
        showCancelButton: true,
        confirmButtonText: `Apply ${discount}% discount`,
        cancelButtonText: "Keep old discount",
        confirmButtonColor: this.bulmaColor("primary"),
        cancelButtonColor: this.bulmaColor("info"),
      }).then((val) => {
        this.showDiscount = false;
        if (val.value) this.applyDiscount(discount);
      });
    },
    applyDiscount(discount) {
      this.infoToast(`Discount ${discount}% applied to menu`);
      this.items.forEach((o) => {
        o.discount = discount;
      });
      this.saveMenu();
    },
    hasPicClass(o) {
      if (o.pic) return "has-text-success";
      return "has-text-danger";
    },
    addItemToMenu() {
      if (this.invalidItems()) return;
      var id = shortid.generate();
      var o = { id: id, name: null, description: null, price: null, pic: null };
      this.items.push(o);
      // scroll to bottom of menu to see new item
      var opts = { top: 99999, behavior: "smooth" };
      if (this.showMenu) {
        this.$nextTick(() => this.$refs.scrollable.scrollTo(opts));
      }
    },
    deleteMenuItem(idx) {
      var item = this.items[idx];
      if (!item.name && !item.price && !item.description) {
        this.items.splice(idx, 1); // if item is empty
        return; // delete without double confirmation
      }
      this.$swal({
        // title: "Delete Item?",
        // text: "Are you sure you want to delete this item?",
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
<i class='far fa-trash-alt'></i>&nbsp;Delete Item?
        </p>
        <p>
Are you sure you want to delete this item?   
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        confirmButtonText: "Yes, Delete It",
      }).then((val) => {
        if (val.value) this.items.splice(idx, 1);
      });
    },
    viewPolygon() {
      this.$router.push(`/shop/${this.role.business_id}?tab=info`); // unused
    },
    editMenu() {
      this.goto("/commerce_page/menu-product-list");
      // if (this.showMenu) this.saveMenu();
      // else this.showMenu = true;
    },
    editDescription(o) {
      var imgURL = o.pic || this.$store.state.errorProfilePic;
      this.$swal({
        input: "textarea",
        html: `
        <p style='text-align:left; font-size:0.9em; font-weight: 500; margin-bottom:4px'>
        <i>Edit Description</i>
        </p>
          <img src='${imgURL}' style='max-height:300px; border-radius:3px; box-shadow: 1px 1px 2px #bbb' />
          <p style='text-align:left; margin-bottom:7px; margin-top:3px; font-size:1.2em'>${o.name}</p>
        `,
        inputValue: o.description || "",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Save Description"),
      }).then((val) => {
        if (val.value) {
          console.log("description", val.value);
          o.description = val.value;
        }
      });
    },
    editStaffNotes(o) {
      this.$swal({
        input: "textarea",
        title: o.name,
        imageUrl: o.pic || this.$store.state.errorProfilePic,
        imageHeight: "200px",
        inputValue: o.notes || "",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Save Staff Notes"),
        confirmButtonColor: "orange",
      }).then((val) => {
        if (val.value) {
          o.notes = val.value;
          this.showStaffNotes = false;
          this.showStaffNotes = true;
        }
      });
    },
    invalidItems() {
      // remove last item if it's blank
      if (this.items.length === 0) return false; // empty list
      var last = this.items[this.items.length - 1];
      if (!last.name && !last.price && !last.description) {
        this.items.pop();
        this.infoToast("Removed blank item", "top");
      }
      var missing = this.items.find((o) => !o.name || !o.price);
      if (missing) {
        var msg = `Invalid menu items. Please set name and price or delete item.`;
        this.warningAlert(msg);
        return true;
      }
      return false;
    },
    saveMenu() {
      this.saveContent();
      if (this.invalidItems()) return;
      // set data
      if (this.menu) {
        this.menu.data = this.items;
      } else {
        this.menu = {
          parent_type: "workflow",
          parent_id: this.role.workflow_id,
          blob_type: "digital_menu",
          data: this.items,
          // data: {
          //   items: this.items,
          //   languages: this.languages
          // }
        };
      }
      // dispatch
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", this.menu)
        .then((res) => {
          this.menu = res.data;
          this.successToast("Menu Saved!");
          // this.showMenu = false; // hide after save
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    initBlobs(blobs) {
      // this.live = res.data.live;
      // this.promo = res.data.promo;
      this.menu = blobs.find((b) => b.blob_type === "digital_menu");
      if (this.menu) this.items = this.menu.data;
      if (this.items.length === 0) this.addItemToMenu();
      this.setContentLang("en", true);
      if (this.items[0].languages) {
        this.languageBool = this.items[0].languages[this.contentLang];
      }
    },
    getBlobs() {
      if (!this.role) {
        this.warningAlert("Invalid Role");
        return;
      }
      this.updating = true;
      setTimeout(() => (this.updating = false), 1500);
      // get all blobs for this workflow
      this.$store
        .dispatch("getBlobsForWorkflow", this.role.workflow_id)
        .then((res) => {
          console.log("getBlobsForWorkflow", res);
          if (res.data) this.initBlobs(res.data); // if there are blobs, initialise them
        })
        .catch((err) => this.apiError(err));
    },
    takePhoto(idx) {
      this.picIndex = idx;
      if (!this.items[idx].pic) return this.$refs.file.click();
      var name = this.items[idx].name;
      var imgURL = this.items[idx].pic;
      this.$swal({
        html: `
        <p style='text-align:left; font-size:0.9em; font-weight: 500; margin-bottom:4px'>
        <i>Edit Picture</i>
        </p>
          <img src='${imgURL}' style='max-height:300px; border-radius:3px; box-shadow: 1px 1px 2px #bbb' />
          <p style='text-align:left; margin-bottom:7px; margin-top:3px; font-size:1.2em'>${name}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Upload New Picture"),
        // confirmButtonColor: "purple",
      }).then((val) => {
        if (val.value) this.$refs.file.click();
      });
    },
    uploadMenuPic(e) {
      console.log("uploadMenuPic", e, e.target);
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB
          this.zFile += 1;

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.role.business_id,
                imageType: "digital_menu",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  // var url = JSON.parse(res.data.body).Location;
                  var url = res.data.compressed_image_url;
                  this.items[this.picIndex].pic = url;
                  this.successToast("Success!");
                  // this.save();
                  // this.toggle = true; // open pic toggle
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  max-width: 600px;
  height: 100vh;
  background-color: whitesmoke;
  z-index: 21;
  overflow: hidden;
}
.header {
  padding: 16px;
  text-align: left;
  font-size: 1.35em;
  font-weight: 500;
}
.wrapper {
  /* padding: 16px; */
  /* padding-bottom: 100px;
  margin-bottom: 100px; */
  text-align: left;
  height: 100vh;
  /* height: 100%; */
  overflow: scroll;
}
.tag {
  padding: 0 6px;
}
.label {
  margin-top: 12px;
  color: grey;
}
.full-width {
  width: 100vw !important;
}
.discounts {
  /* background-color: snow; */
}
.discounts span {
  margin-right: 8px;
}
.button.is-small.is-rounded {
  padding: 0 4px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.is-marginless .tag {
  margin: 0 0;
}
.notes p {
  margin-top: -2px;
  border: 1px solid rgb(240, 240, 240);
  /* border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px; */
  padding: 4px 8px;
  white-space: pre-wrap;
}
.input.is-light {
  background-color: rgb(250, 250, 250);
}
/* .updating {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px;
} */
.advanced-btn {
  height: 30px;
  font-size: 0.85em;
  /* padding: 12px; */
}
.notification {
  text-align: left;
  padding: 16px;
  position: fixed;
  bottom: 0;
  border-radius: 0;
  width: 100vw;
  max-width: 600px;
}
.menu {
  border-top: 0.5px solid #eee;
  margin-top: 8px;
  overflow: scroll;
  max-height: calc(100vh - 164px);
}
.not-menu {
  overflow: scroll;
  max-height: calc(100vh - 140px);
  padding-bottom: 100px;
  /* margin-top: 5px; */
}
.hint {
  /* font-weight: 500; */
  opacity: 0.6;
}
.notes i {
  white-space: normal;
}
.item-state {
  position: absolute;
  right: 0px;
  top: 2px;
  opacity: 0.7;
  padding: 3px;
}
.link {
  /* font-weight: 0; */
  color: grey;
  font-size: 0.9em;
}
.row-wrapper {
  background-color: white;
  padding: 1px 16px;
  margin-bottom: 8px;
}
.setting {
  font-weight: 500;
  color: grey;
}
.setting-row {
  margin: 12px 0;
}
.setting i {
  display: inline-block;
  width: 20px;
  text-align: center;
}
.menu-item {
  margin-bottom: 8px;
  /* box-shadow: 1px 1px 1px rgb(216, 216, 216); */
}
img {
  /* margin: -1px;
  border-radius: 2px; */
  object-fit: cover;
  height: 36px;
  width: 36px;
  box-shadow: 0px 0px 1px grey;
}
.empty-search {
  padding: 10px;
  background-color: linen;
}
.search {
  position: absolute;
  top: 50px;
  left: 0;
  padding: 2px 16px;
  width: 100%;
  background-color: white;
}
.other-discount {
  background-color: lightgreen;
  padding: 4px;
  border-radius: 20px;
  line-height: 1em;
  margin-left: 4px;
  box-shadow: 0 0 1px grey;
}
hr {
  height: 9px;
  margin: 12px 0px;
  /* background-color: white; */
}
</style>

<style>
.swal2-textarea {
  margin: 0;
}
.swal2-close {
  color: grey;
}
</style>